import CalendarPage from 'pages/Calendar'
import { CalendarStateProvider } from 'context/CalendarContext'

export const CalendarRoot = {
  key: 'CalendarRoot',
  label: 'Calendar',
  path: '/calendar',
  element: (
    <CalendarStateProvider>
      <CalendarPage />
    </CalendarStateProvider>
  ),
  defaultPath: '/calendar',
  trackingName: 'calendar',
}

